import React, { useState } from 'react';
import { Box } from '@mui/material';
import { DISPLAY_FONT, monogram, tok } from '../theme/businessTheme';

interface Props {
  name: string;
  logoUrl?: string | null;
  size: number;
  radius?: number | string;
  /** Override the plate color (defaults to the logoBackdrop token). */
  plate?: string;
  ring?: string;
}

/** Logo on its `logoBackdrop` plate; monogram (onHeroCard) when no logo. */
const BusinessLogo: React.FC<Props> = ({ name, logoUrl, size, radius, plate, ring }) => {
  const [failed, setFailed] = useState(false);
  const showImg = !!logoUrl && !failed;
  return (
    <Box
      aria-hidden="true"
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: radius ?? `${Math.round(size * 0.3)}px`,
        background: plate ?? tok('logoBackdrop'),
        color: tok('onHeroCard'),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        boxSizing: 'border-box',
        border: ring ? `3px solid ${ring}` : undefined,
        fontFamily: DISPLAY_FONT,
        fontWeight: 800,
        fontSize: Math.round(size * 0.36),
        letterSpacing: '-0.02em',
      }}
    >
      {showImg ? (
        <img
          src={logoUrl as string}
          alt=""
          onError={() => setFailed(true)}
          style={{ width: '100%', height: '100%', objectFit: 'contain', padding: Math.round(size * 0.1), boxSizing: 'border-box' }}
        />
      ) : (
        monogram(name)
      )}
    </Box>
  );
};

export default BusinessLogo;
